<template>
  <div>
    <div class="card-header">
      <div class="card-header-title">
        {{ title }}&nbsp; total: {{ filtered_review_set.total_count }}
      </div>
      <div class="is-pulled-right pad">
                    <span class="tag">
                      <span class="icon" v-if="loading">
                        <i class="fas fa-spinner fa-spin"></i>
                      </span>
                    </span>
      </div>
      <!-- <button @click="debug()">debug</button> -->
    </div>
    <div v-if="!hasRequiredFilter" class="has-text-centered has-text-grey p-4">
      Sélectionnez un établissement, un sentiment ou une période pour charger les avis.
    </div>
    <div class="list" v-show="hasRequiredFilter" :style="style" ref="list">
      <div
          class="list-item clickable my-list-item"
          v-for="item in filtered_review_set.results"
          :key="item.uid"
          @click="select(item.uid)"
          :class="{ selected: item.uid == selected_review_uid }"
      >
                    <span
                        class="tag is-pulled-right state-name"
                        :class="get_class(item.current_state.class_name)"
                    >
                      <span>
                        {{ item.current_state.verbose_name }}
                        {{ get_tag_name(item.current_state.tag) }}
                      </span>
                    </span>
        <span class="date is-pulled-left">
                      {{ local_date(item.published_on) }}&nbsp;
                    </span>
        <span class="tag is-pulled-left">{{ item.platform.name }}</span>
        <span class="tag is-pulled-left">{{ item.mark }}</span>
        <span class="tag is-pulled-left">
                      <i
                          class="fa"
                          :class="{
                          'fa-thumbs-up': item.positive,
                          'fa-thumbs-down': !item.positive
                        }"
                      ></i>
                    </span>
        <span
            class="tag tag-consultant"
            v-if="item.establishment.consultant"
        >
                      {{ item.establishment.consultant.fullname }}
                    </span>
        <span
            class="review-title"
            v-if="[null, ''].indexOf(item.title_fr) < 0"
        >
                      {{ item.title_fr }}
                    </span>
        <span
            class="review-title"
            v-else-if="[null, ''].indexOf(item.title_native) < 0"
        >
                      {{ item.title_native }}
                    </span>
        <span class="review-title" v-else>Pas de titre</span>
        <span class="info" v-if="[null, ''].indexOf(item.text_fr) < 0">
                      {{ item.text_fr }}
                    </span>
        <span class="info" v-else-if="[null, ''].indexOf(item.text_native) < 0">
                      {{ item.text_native }}
                    </span>
        <span class="info" v-else>Pas de texte</span>
        <span
            class="info is-pulled-right"
            :title="item.establishment.name"
        >
                      {{ ellipsis(item.establishment.name, 25) }}
                    </span>
        <span class="info author">{{ item.author }}</span>
      </div>
      <div class="list-item">&nbsp;
        <span v-if="loading">
                      <i class="fa fa-spinner fa-spin"></i>
                      <span>&nbsp; Chargement</span>
                    </span>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils.js'
import REVIEW_SET_PAGINATED_SIMULATION from '@/gql/queries/reviewSetPaginatedSimulation.graphql'
import { gqlQuery } from '@/gqlClient.js'

export default {
  name: 'ReviewListPaginatedForSimulation',
  props: {
    title: String,
    autoload: Boolean,
    height: String,
    filters: {
      type: Object
    }
  },
  data() {
    return {
      selected_review_uid: null,
      test: {a: null, b: 1},
      loading: true,
      reviews: [],
      totalCount: 0,
      currentOffset: 0,
      inQuery: false,
    }
  },
  computed: {
    style() {
      return {
        height: this.height
      }
    },
    filtered_review_set() {
      return {
        results: this.reviews,
        total_count: this.reviews.length
      }
    },
    hasRequiredFilter() {
      const f = this.filters || {};
      return !!(
          (f.establishment && f.establishment.uid) ||
          (f.sentiment && f.sentiment.value != null) ||
          f.dateBeginFilter ||
          f.dateEndFilter
      );
    }
  },
  methods: {
    keydown(e) {
      if (e.target.tagName !== 'TEXTAREA') {
        switch (e.keyCode) {
          case 40:
            e.preventDefault()
            break
          case 38:
            e.preventDefault()
            break
        }
      }
    },
    keyup(e) {
      if (e.target.tagName !== 'TEXTAREA') {
        switch (e.keyCode) {
          case 40:
            this.next()
            break
          case 38:
            this.prev()
            break
        }
      }
    },
    next() {
      let index = 0
      for (let r of this.filtered_review_set.results) {
        if (r.uid == this.selected_review_uid) break
        index += 1
      }
      if (index + 1 < this.filtered_review_set.results.length) {
        this.select(this.filtered_review_set.results[index + 1].uid)
      }
      const visible_objects = Math.floor(this.$refs['list'].offsetHeight / 82)
      const to_scroll = index * 82 - (visible_objects - 2) * 82
      if (to_scroll > 0) {
        this.$refs['list'].scroll(0, to_scroll)
      }
    },
    prev() {
      let index = 0
      for (let r of this.filtered_review_set.results) {
        if (r.uid == this.selected_review_uid) break
        index += 1
      }
      if (index - 1 >= 0) {
        this.select(this.filtered_review_set.results[index - 1].uid)
      }
      const visible_objects = Math.floor(this.$refs['list'].scrollTop / 82)
      const scrolled = this.$refs['list'].scrollTop
      const to_scroll = index * 82 - (visible_objects + 1) * 82
      if (to_scroll < 0) {
        this.$refs['list'].scroll(0, this.$refs['list'].scrollTop + to_scroll)
      }
    },
    select(uid) {
      this.selected_review_uid = uid
      this.$emit('select_review', uid)
    },
    debug() {
      this.test['plop'] = 'plip'
    },
    async fetchReviews(append = false) {
      if (!this.hasRequiredFilter) {
        this.reviews = [];
        this.loading = false;
        return;
      }
      this.loading = true
      if (this.inQuery) return
      this.inQuery = true
      const vars = this.buildQueryVars()
      if (append) vars.offset = this.currentOffset
      const res = await gqlQuery(REVIEW_SET_PAGINATED_SIMULATION, vars)
      const data = res.body.data.review_set_paginated || []
      if (append) {
        const seen = new Set(this.reviews.map(r => r.uid))
        this.reviews = this.reviews.concat(data.filter(r => !seen.has(r.uid)))
      } else {
        this.reviews = data
        this.currentOffset = 0
      }
      if (data.length > 0) {
        this.totalCount = data[0].total_count
        this.currentOffset += data.length
      }
      this.loading = false
      this.inQuery = false
    },
    buildQueryVars() {
      const f = this.filters || {}
      const vars = {}
      if (f.platform && f.platform.uid) vars.platform = f.platform.uid
      if (f.establishment && f.establishment.uid) vars.establishment = f.establishment.uid
      if (f.consultant && f.consultant.uid) vars.consultant_uid = f.consultant.uid
      if (f.search_string) vars.search_vector = f.search_string
      if (f.sentiment) vars.positive = f.sentiment.value
      if (f.status) vars.current_state_class_name = f.status.value
      if (f.classified) vars.current_state_class_name = 'Classified'
      if (f.dateBeginFilter) vars.published_on_gte = f.dateBeginFilter
      if (f.dateEndFilter) vars.published_on_lte = f.dateEndFilter
      if (f.tag && f.tag.name != null) vars.current_state_tag_iexact = f.tag.code
      if (f.has_game_filter) vars.has_game_set = true
      vars.establishment_active = true
      return vars
    },
    async loadNextPage() {
      await this.fetchReviews(true)
    },
    async query() {
      this.currentOffset = 0
      await this.fetchReviews()
    },
    debouncedQuery: utils.debounce(function () {
      this.query()
    }, 2000),
    get_class(state_name) {
      return ['state-' + state_name.toLowerCase()]
    },
    get_tag_name(tag) {
      let ret = null
      if (tag) {
        ret = this.$store.state.tag_name[tag.toLowerCase()]
      }
      return ret
    },
    handleScroll(e) {
      if (
          e.srcElement.offsetHeight + e.srcElement.scrollTop ===
          e.srcElement.scrollHeight
      ) {
        this.loadNextPage()
      }
    },
    local_date(date) {
      // Remplacer par votre filtre local_date
      return date
    },
    ellipsis(str, len) {
      if (!str) return ''
      return str.length > len ? str.substring(0, len) + '...' : str
    }
  },
  async mounted() {
    if (this.autoload) {
      await this.fetchReviews()
    } else {
      this.loading = false
    }
    this.$refs.list.addEventListener('scroll', this.handleScroll)
    if (this.$route.params.uid) {
      this.$store.dispatch('select_review', this.$route.params.uid)
    }
    window.addEventListener('keydown', this.keydown, false)
    window.addEventListener('keyup', this.keyup, false)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.keydown)
    window.removeEventListener('keyup', this.keyup)
  },
  watch: {
    filters(newV, oldV) {
      if (newV.search_string != oldV.search_string) {
        this.debouncedQuery(newV)
      } else {
        this.query(newV)
      }
    }
  }
}
</script>

<style>
.pad {
  padding: 0.75rem;
}

.list {
  overflow-y: scroll;
}
</style>

<style lang="scss" scoped>
.selected {
  background-color: #eee;
}

.card-header-title {
  padding: 10px 0 10px 10px;
}

.card-header {
  height: 40px;
}

.state-name {
  width: calc(100% - 280px) !important;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  text-align: center;
  padding-top: 2px;
}

.tag-consultant {
  font-size: 0.8em;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 70px;
  text-align: left;
  display: inline-block;
  padding-top: 4px;
}

.review-title {
  font-size: 0.8em;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  max-width: 35vw;
}

.author {
  height: 20px;
}

.card-header {
  padding: 0 !important;
  display: flex;
}

.tag {
  background-color: rgba(0, 0, 0, 0);
}
</style>